import { HIP } from '@eab-eip/hi-hip/hi-hif';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined.js';

import f1 from '@eab-pip/pi-f1';

const entity = 'dashboard';

HIP.visitor.add({
  entity,
  render_type: 'metric',
  build: (fieldType: Record<string, unknown>, builderEl: Element & { ns: string }) => {
    const metricConfig: any = !f1.is.empty(f1.read(f1.lens(`/report/render/${fieldType.name}`), {}, builderEl))
      ? f1.read(f1.lens(`/report/render/${fieldType.name}/render/render_hints/metric`), {}, builderEl)
      : f1.read(f1.lens(`/report/${fieldType.name}/render/render_hints/metric`), {}, builderEl);

    const icon = ifDefined(f1.read('/icon', undefined, metricConfig));
    const prefix = ifDefined(f1.read('/prefix', undefined, metricConfig));
    const aesthetic = ifDefined(f1.read('/aesthetic', undefined, metricConfig));
    const label = ifDefined(f1.read('/label', undefined, metricConfig));
    const labelText = ifDefined(f1.read('/label_text', undefined, metricConfig));
    const trend = ifDefined(f1.read('/trend', undefined, metricConfig));
    const theme = ifDefined(f1.read('/theme', undefined, metricConfig));

    return html`
      <div style="display:flex;justify-content: center;margin-top:1em;">
        <vi-metric
          id="${fieldType.name}"
          gid="${fieldType.name}"
          ns="${builderEl.ns}"
          header="${metricConfig.header}"
          value="${metricConfig.value}"
          aesthetic="${aesthetic}"
          prefix="${prefix}"
          icon="${icon}"
          label-text="${labelText}"
          label="${label}"
          theme="${theme}"
          trend="${trend}"
        >
        </vi-metric>
      </div>
    `;
  }
});
